import PropTypes from "prop-types";
import { styled, alpha } from "@mui/material/styles";
import {
  Toolbar,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import { Icon } from "@iconify/react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  padding:'0px 10px',
  height: 96,
  display: "flex",
  justifyContent: "space-between",
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  marginRight:"10px",
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": {
    width: 320,
    boxShadow: theme.customShadows,
  },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

UserListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
};

export default function UserListToolbar({
  numSelected,
  filterName,
  onFilterName,
  handleChange,
  filterData,
  setFilterData,
}) {
  return (
    <StyledRoot>
      <StyledSearch
        value={filterName}
        onChange={onFilterName}
        placeholder="Search tickets..."
        startAdornment={
          <InputAdornment position="start">
            <Icon
              icon="eva:search-fill"
              sx={{ color: "text.disabled", width: 20, height: 20  }}
            />
          </InputAdornment>
        }
      />

      <FormControl sx={{ width: 250,  }}>
        {/* <InputLabel id="demo-simple-select-autowidth-label">
          Filter Tickets
        </InputLabel> */}
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          value={filterData}
          onChange={handleChange}
          autoWidth
          // label="Filter Tickets"
        >
          <MenuItem value="To Do" sx={{ width: 250 }}>
            Open Tickets
          </MenuItem>
          <MenuItem value="Done">Closed Tickets</MenuItem>
          <MenuItem value="In Progress">In Progress Tickets</MenuItem>
          <MenuItem value="On Hold">On Hold Tickets</MenuItem>
          <MenuItem value="Testing">Testing Tickets</MenuItem>
          {/* <MenuItem value="delivered">Resolved Tickets</MenuItem> */}
          <MenuItem value="All">All Tickets</MenuItem>
        </Select>
      </FormControl>
    </StyledRoot>
  );
}
